/* eslint-disable no-unused-vars */
import React from "react";
import { Card } from "antd";
import "./index.scss";

const AgeingBuckets = () => {
  return (
    <Card className="ageing-buckets-card">
      <div className="ageing-buckets-header">
        <h3 className="card-title">Ageing Buckets</h3>
      </div>
      <div className="ageing-buckets-content coming-soon">
        <div className="coming-soon-message">
          <span className="coming-soon-text">Coming Soon</span>
        </div>
      </div>
    </Card>
  );
};

export default AgeingBuckets;

